import React from 'react'
import { SxProps, Theme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import colors from '@/assets/scss/_themes-vars.module.scss'

export type InfoSectionProps = React.PropsWithChildren<{
  action?: React.ReactNode
  /**
   * The label content
   */
  label: string
  /**
   * Optional one-line explanation shown under the title — what this section/feature does.
   */
  description?: React.ReactNode
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   * See the [`sx` page](https://mui.com/system/the-sx-prop/) for more details.
   */
  sx?: SxProps<Theme>
}>

export function InfoSection(props: InfoSectionProps) {
  const { action, children, description, label, sx } = props

  return (
    <Box sx={sx}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: 500, color: colors.gray900 }}>
          {label}
        </Typography>
        {action}
      </Stack>
      {description && (
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          {description}
        </Typography>
      )}
      {children}
    </Box>
  )
}

export default InfoSection
